(<template>
  <div>
    <transition name="el-fade-in-linear">
      <div v-show="show" class="reported-div">
          <h2 class="reported-title" v-translate>Reported comments</h2>
          <hr class="delimiter">
          <div class="reported-comment-list">
            <el-card class="comment"
                     v-for="comment in commentList"
                     :key="comment.id"
                     :body-style="{ padding: '0px' }">
                <div class="comment-title" slot="header">
                  <span class="comments-user-icon" :style="{background: getColor(comment.createdBy)}">
                    {{comment.createdBy[0].toUpperCase()}}
                  </span>
                  <div class="comment-title-and-content">
                    <strong class="comment-title-content">{{comment.createdBy}}</strong>
                    <div class="report-numbers">
                      <i class="el-icon-warning red-icon"></i>{{comment.reports}}&nbsp;
                    </div><br />
                    <span class="comment-title-content">{{getDateTime(comment.date)}}</span>
                    <el-button class="delete-icon"
                               type="text"
                               icon="el-icon-delete"
                               @click="remove(comment.id)">
                    </el-button>
                  </div>
                </div>
                <p class="comment-content">
                  {{comment.comment}}
                </p>
            </el-card>
          </div>
      </div>
    </transition>
    <el-button  @click="show=!show" id="right-hide-button" size="mini">
      <div id="vertical-right">
        <span v-translate>Reported comments</span>
      </div>
    </el-button>
  </div>
</template>)

(<script>
import axios from 'axios'
import StringToColor from 'string-to-color'

export default {
  name: 'monument-list',
  data () {
    return {
      commentList: [],
      show: true
    }
  },
  created () {
    this.getReportedCommentList()
  },
  methods: {
    getColor (string) {
      return `#${StringToColor.generate(string)}`
    },
    getDateTime (dateString) {
      var now = new Date()
      var date = new Date(dateString)
      if (now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth() && now.getDate() === date.getDate()) {
        return date.toTimeString().split(' ')[0]
      } else {
        return dateString.slice(0, 10).replace(/-/g, ' ')
      }
    },
    getReportedCommentList () {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/comments/reported`,
        withCredentials: true
      })
      .then(response => {
        this.commentList = response.data
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    remove (id) {
      axios({
        method: 'delete',
        url: `${process.env.SERVER_URL}/comments/${id}`,
        withCredentials: true
      })
      .then(() => {
        this.$message({
          type: 'success',
          message: this.$gettext('Comment deleted successfully!')
        })
        this.getReportedCommentList()
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    }
  }
}
</script>)

(<style>
#vertical-right {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}
.reported-title {
  font-size: 120%;
  text-align: center;
  padding: 0.5em;
}
.reported-div {
  float: right;
  background-color: #bde5ef;
  width: 20%;
  padding-bottom: 1em;
  padding-left: 1em;
  padding-right: 1em;
  right: 2em;
  display: inline-block;
  position: absolute;
  top: 8em;
  height: 70vh;
}
.reported-comment-list {
  overflow-y: scroll;
  height: 85%;
}
.red-icon {
  color: red;
  float: right;
}
.delete-icon {
  float: right;
  font-size:  1.3em;
  color: black;
  padding: 0.2em 0.35em 0em 0em;
}
.comment {
  margin-bottom: 5px;
  border-radius: 5px;
}
.comment-content {
  color: #666666;
}
.report-numbers {
  float: right;
}
#right-hide-button {
  position: fixed;
  right: 0px;
  top: 0px;
  height: 100vh;
  width: 1em;
}
.comments-user-icon {
  width: 2em;
  height: 2em;
  line-height: 2em;
  display: block;
  border-radius: 50%;
  text-align: center;
  color: white;
}
.comment-title-and-content {
  width: 100%;
  text-align: left;
}
@media screen and (max-width: 1200px) {
  .reported-div {
    position: relative;
    top: 2em;
    width: 40%;
    margin-bottom: 8em;
  }
  .reported-comment-list {
    overflow-y: scroll;
    height: 20em;
  }
}
</style>)



// WEBPACK FOOTER //
// src/components/Reported-Comments-Newsfeed.vue